import React, { useState } from "react";
import EmailDocumentsDialog from "./EmailDocumentsDialog";

const PaymentSummary = ({ setPaymentData, InvoiceDetails ,setshowOutstanding}) => {

  const [Emailsummary, setEmailsummary] = useState(false);

  return (
    <div>
      <div className="!w-[1340px] flex">
        <button
          className="cursor-pointer h-fit w-fit"
          aria-label="Invoices page return button"
          onClick={()=>setshowOutstanding(true)}
        >
          <div className="flex items-center justify-start mr-[4px]">
            <p className="mr-[4px] text-secondary-blue-link">Invoices</p>
            <svg width="20" height="20" fill="none">
              <path
                d="m7.308 15.922 5.384-5.923-5.384-5.923"
                stroke="#A09F9F"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </button>
        <button
          className="cursor-pointer h-fit w-fit"
          aria-label="Past payments page return button"
          onClick={() => setPaymentData(null)}
        >
          <div className="flex items-center justify-start mr-[4px]">
            <p className="mr-[4px] text-secondary-blue-link">Past Payments</p>
            <svg width="20" height="20" fill="none">
              <path
                d="m7.308 15.922 5.384-5.923-5.384-5.923"
                stroke="#A09F9F"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </button>
        <p className="font-bold mb-[40px]">
          Payment #{InvoiceDetails.paymentNo}
        </p>
        <div className="ml-auto mr-0">
          <button
            className="flex focus:bg-[#F8F8F8] font-semibold h-[40px] hover:bg-[#F8F8F8] outline-neutrals-black px-4 py-2 rounded-sm"
            onClick={() => setPaymentData(null)}
          >
            <img
              role="presentation"
              aria-hidden="true"
              className="h-[12px] mr-4 mt-[6px] w-[12px]"
              src="../../arrow-left.e8cef756.svg"
              alt="back arrow"
            />
            Back
          </button>
        </div>
      </div>
      <div className="!h-fit !w-[1060px] border border-[#A09F9F] mb-[400px] mx-auto my-0 rounded-[3px]">
        <div className="!w-[1018px] flex items-center justify-center mt-[24px] pl-[16px]">
          <div className="p-6">
            <p className="!font-bold text-[22px]">
              Payment Summary #{InvoiceDetails.paymentNo}
            </p>
            <div className="flex mt-[24px]">
              <p className="mr-4 text-[16px]">Payment Date:</p>
              <p>{InvoiceDetails.paymentDate}</p>
            </div>
          </div>
          <div className="flex items-center ml-auto mr-6">
            <button
              id="email-selected"
              className="!h-[40px] bg-transparent border border-neutrals-black btn__secondary pl-2 pr-4 py-2 w-[195px]"
              onClick={()=>setEmailsummary(true)}
            >
              <svg
                className="float-left mr-2"
                width="20"
                height="20"
                fill="none"
              >
                <path
                  d="M3.6 4h12.8c.88 0 1.6.675 1.6 1.5v9c0 .825-.72 1.5-1.6 1.5H3.6c-.88 0-1.6-.675-1.6-1.5v-9C2 4.675 2.72 4 3.6 4Z"
                  stroke="#000"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="m17 5-7 6-7-6"
                  stroke="#000"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Email Summary
            </button>
          </div>
        </div>
        <div className="!w-[980px] border border-[#A09F9F] mx-auto my-0 rounded-[3px] mb-16">
          <div className="bg-[#FFF6DF] border-[#A09F9F] border-b flex font-[600] h-[60px] items-center justify-center pl-[32px] pr-[32px] rounded-t-[2px] text-[14px] mb-3">
            <div className="py-[14px] text-left w-[800px]">Description</div>
            <div className="py-[14px] text-left w-[100px]">#</div>
            <div className="py-[14px] text-right w-[80px]">Rate</div>
            <div className="py-[14px] text-right w-[140px]">Total</div>
          </div>
          <div id="table-content">
            <div className="!h-fit flex font-[400] order-content pl-[32px] pr-[32px] text-[14px]">
              <div className="mr-[40px] pb-[16px] pt-[24px] w-[980px]">
                <div className="!font-bold flex text-left w-[946px]">
                  <p className="mr-4">{InvoiceDetails.PaymentMethod}</p>
                  <p>
                    {InvoiceDetails.ccCardType} {InvoiceDetails.ccMaskNumber}
                  </p>
                  <div className="flex ml-auto mr-0">
                    <p className="w-[104px]">{InvoiceDetails.paymentTotal}</p>
                  </div>
                </div>
                
                  <div className="mr-[40px] pb-[16px] pt-[24px] w-[980px]">
                {InvoiceDetails.invoiceDetails.map((item) => {
                  return (
                    <div className="Hello">
                    
                      <div className="flex mt-2 w-[946px]">
                        <p className="mr-4">Lawyer:</p>
                        <p className="font-semibold">{item.lawyerName}</p>
                      </div>
                      <div className="flex mt-2 w-[946px]">
                        <div className="flex mr-8">
                          <p className="mr-4">Invoice #</p>
                          <p className="font-semibold text-secondary-blue-link">
                            {item.invoiceNo}
                          </p>
                        </div>
                        <div className="flex">
                          <p className="mr-4">Order #</p>
                          <p className="font-semibold">{item.fileNumber}</p>
                        </div>
                      </div>
                      {item.invoiceLineItems.map((lineitem,index) => {
                        return (
                          <div>
                            <div className="flex mt-5 w-[946px]">
                              <p>{lineitem.itemDesc}</p>
                              <div className="flex ml-auto mr-0">
                                <p className="w-[88px]">{lineitem.quantity}</p>
                                <p className="w-[116px]">{lineitem.rate}</p>
                                <p className="w-[90px]">{lineitem.Total}</p>
                              </div>
                            </div>
                            { index !== item.invoiceLineItems.length-1 &&
                            <hr className="border-line-thick mt-4 w-[924px]" />
                      }
                            </div>
                           
                        );
                      })}
                      
                      <hr className="!border-placeholder border-line-thick mt-4 w-[924px]" />
                      <div className="flex mt-3 w-[946px]">
                        <div className="flex ml-auto mr-0">
                          <p className="font-semibold w-[100px]">Subtotal</p>
                          <p className="w-[102px]">${item.invoiceTotal}</p>
                        </div>
                      </div>
                    </div>
                  );
                })}
                </div>
              </div>
            </div>
          </div>
        </div>
        {Emailsummary && 
        
        <EmailDocumentsDialog setEmailsummary={setEmailsummary}/>
        }
      </div>
    </div>
  );
};

export default PaymentSummary;
